export default "__VITE_ASSET__0830a9fb__"